var _circle, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#F6F7F7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    transform: "translate(14 14)",
    fill: "#F6F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8333 40.25V34.4167H42V40.25H26.8333ZM40.8333 35.5833H28V39.0833H40.8333V35.5833ZM30.3333 29.75H40.8333V26.25H30.3333V25.0833H42V30.9167H30.3333V29.75ZM26.8333 15.75H42V21.5833H26.8333V15.75ZM28 20.4167H40.8333V16.9167H28V20.4167ZM21.5833 33.25C17.3833 33.25 14 28 14 28C14 28 17.3833 22.75 21.5833 22.75C25.7833 22.75 29.1667 28 29.1667 28C29.1667 28 25.7833 33.25 21.5833 33.25ZM21.5833 23.9167C18.025 23.9167 15.1667 28 15.1667 28C15.1667 28 18.025 32.0833 21.5833 32.0833C25.1417 32.0833 28 28 28 28C28 28 25.1417 23.9167 21.5833 23.9167ZM21.5833 30.9167C19.95 30.9167 18.6667 29.6333 18.6667 28C18.6667 26.3667 19.95 25.0833 21.5833 25.0833C23.2167 25.0833 24.5 26.3667 24.5 28C24.5 29.6333 23.2167 30.9167 21.5833 30.9167ZM21.5833 26.25C20.5917 26.25 19.8333 27.0083 19.8333 28C19.8333 28.9917 20.5917 29.75 21.5833 29.75C22.575 29.75 23.3333 28.9917 23.3333 28C23.3333 27.0083 22.575 26.25 21.5833 26.25Z",
    fill: "#A3B0B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading1);
export default __webpack_public_path__ + "static/media/loading1.732307465b0291fcf945f39f4f350182.svg";
export { ForwardRef as ReactComponent };